import type { ActionContext } from 'vuex'

import type { ActionClass, AppState } from '../../../models'

import { APP_CONSTS } from '../app.consts'

export class SetLoadingAction implements ActionClass {
  static execute(this: void, { commit }: ActionContext<AppState, any>, loading: boolean): void {
    commit(APP_CONSTS.mutations.setLoading, {
      loading,
    })
  }
}
